import Header from '../components/Header';
import Hero from '../components/Hero';
import FreshMenus from '../components/FreshSaladMenu';
import CustomerReviews from '../components/CustomerReview';
import Footer from '../components/Footer';
import NutritionalValue from '../components/NutritionalValues';
import About from '../components/AboutUs';
import MissionValues from '../components/MissonValues';
import ServiceFeatures from '../components/ServiceFeatures';

const HomePage = () => {
  return (
    <>
      <Header />
      <Hero />
      <FreshMenus />
      <NutritionalValue />
      <CustomerReviews />
      <About />
      <MissionValues />
      <ServiceFeatures />
      <Footer />
    </>
  );
};

export default HomePage;
